module.exports = __webpack_public_path__ + "static/firstxmashamper-1dabcb822fbb24d7b36f0b21f003ce95.jpeg";